import React, { useState, useRef } from 'react';
import styles from './TableTopHeader.module.css';
import plus from '../../../assets/Imagess/plusvector.svg';
import del from '../../../assets/Imagess/whiteTrash.svg';
import SearchInput from '../../Atoms/Inputs/SearchInput';
import Buttons from '../../Atoms/Buttons/Buttons';
import ColoredButton from '../../Atoms/Buttons/ColoredButtons/ColoredButton';
import statusicon from '../../../assets/Imagess/status.svg';
import sendEmailICon from '../../../assets/Imagess/email.svg';
import Filter from './Filter';
import TableToPrint from '../../Molecules/Applications/TableToPrint';

const TableTopHeader = ({
  add,
  handleOnAdd,
  user,
  mode,
  selected,
  isApplicant,
  setShowStatusModal,
  setShowEmailModal,
  setProgram,
  setStatus,
  setFieldOfInterest,
  search,
  setSearch,
  refetch,
  handleExport,
  disableControls,
  addLabel,
  rowsCount = 0,
  setDeleteMode,
  selectedUser,
  refetchUsers,
  tableHeader,
  data,
}) => {
  const handleSearch = (e) => {
    // if (e.keyCode === 13) {
    //   setSearch(e.target.value);
    // }
    setSearch(e);
  };
  let componentRef = useRef();

  const [showPrint, setShowPrint] = useState('none');

  class ComponentToPrint extends React.Component {
    render() {
      return (
        <div style={{ display: showPrint }} id={mode + 'Print'}>
          <TableToPrint
            data={data}
            mode={'users'}
            tableHeader={tableHeader}
            showPrint={showPrint}
            setShowPrint={setShowPrint}
          />
        </div>
      );
    }
  }

  return (
    <div className={styles['icon-container']}>
      <div>
        <SearchInput search={search} setSearch={handleSearch} />
      </div>
      {disableControls ? (
        <div className={styles['add-filters']}>
          <Buttons
            text={addLabel}
            icon={plus}
            rounded={true}
            color="rgba(13, 160, 110, 1)"
            handleOnClick={handleOnAdd}
          />
          {/* <Filter
            selected={selected}
            isApplicant={isApplicant}
            setFieldOfInterest={setFieldOfInterest}
            setStatus={setStatus}
            setProgram={setProgram}
            refetch={refetch}
          /> */}
        </div>
      ) : (
        <div className={styles['icon-subcontainer']}>
          {user ? (
            <>
              {selectedUser.length ? (
                <>
                  <div className={`${styles['circle']}`}>
                    <p>{selectedUser.length}</p>
                  </div>
                  <label
                    style={{
                      fontFamily: 'BukraBold',
                      fontSize: '15px',
                      fontWeight: 300,
                    }}
                  >
                    المستخدمون المحددون
                  </label>

                  <Buttons
                    text={mode === 'users' ? 'حذف المحدد' : ''}
                    icon={del}
                    rounded={true}
                    color="#D72222"
                    handleOnClick={setDeleteMode}
                    style={{ fontFamily: 'BukraBold', padding: ' 10px 30px' }}
                    iconWidth="16"
                    iconHeight="18"
                  />
                </>
              ) : null}

              <Buttons
                text={mode === 'users' ? 'مستخدم جديد' : 'دور جديد'}
                icon={plus}
                rounded={true}
                color="rgba(13, 160, 110, 1)"
                handleOnClick={handleOnAdd}
                style={{ fontFamily: 'BukraBold', padding: ' 10px 30px' }}
                iconWidth="18"
                iconHeight="18"
              />
            </>
          ) : (
            <>
              {selected?.length !== 0 && (
                <>
                  <p className={styles['circle-icon']}>{selected?.length}</p>
                  <h5>Selected Applicants</h5>
                </>
              )}
              {selected?.length !== 0 && (
                <>
                  <ColoredButton
                    title="Change Status"
                    backgroundColor="#000"
                    color="rgba(13, 160, 110, 1)"
                    rounded={true}
                    icon={statusicon}
                    handleOnClick={() => setShowStatusModal(true)}
                  />
                  <ColoredButton
                    title="Send Email"
                    backgroundColor="#F3223C"
                    color="rgba(13, 160, 110, 1)"
                    rounded={true}
                    icon={sendEmailICon}
                    handleOnClick={() => setShowEmailModal(true)}
                  />
                </>
              )}
              <Filter
                selected={selected}
                isApplicant={isApplicant}
                setFieldOfInterest={setFieldOfInterest}
                setStatus={setStatus}
                setProgram={setProgram}
                refetch={refetch}
              />
            </>
          )}
          {/* <MoreButton icon={moreInfo}>
            <div className="profile-container">
              <div onClick={handleExport}>
                <img src={exportICon} alt="profile" /> <h4>Export</h4>{" "}
              </div>

              <ReactToPrint
                trigger={() => (
                  <div>
                    <img src={printicon} alt="profile" /> <h4>Print</h4>{" "}
                  </div>
                )}
                content={() => componentRef}
                onAfterPrint={() =>
                  (document.getElementById(mode + "Print").style.display =
                    "none")
                }
                onBeforeGetContent={() => {
                  document.getElementById(mode + "Print").style.display =
                    "block";
                  refetch();
                }}
              />
            </div>
          </MoreButton> */}
        </div>
      )}
      <ComponentToPrint ref={(el) => (componentRef = el)} />
    </div>
  );
};

export default TableTopHeader;
